import Api from './Api';

const END_POINT = 'regimenes'

export default {

    async get_all(filters = null) {
        let request = {
            params: filters
        }
        return await Api.get(`${END_POINT}`, request)
    },
    async store(regimen) {
        return await Api.post(`${END_POINT}`, regimen)
    },
    async update(regimen) {
        return await Api.patch(`${END_POINT}/${regimen.id}`, regimen)
    },
    async change_status(regimen) {
        return await Api.patch(`${END_POINT}/${regimen.id}/change-status`, regimen)
    },
    async delete(regimen) {
        return await Api.delete(`${END_POINT}/${regimen.id}`, regimen)
    },
    async listarActivos() {
        return await Api.get('listarRegimenesActivos');
    }
}